// Lindy Crafts: slider cho section lindy-hero — mũi tên, chấm, tự chuyển (dừng khi hover/focus,
// tắt khi người dùng bật giảm chuyển động), và chọn slide khi bấm block trong Theme editor.
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const init = root => {
    if (root.dataset.lcReady) return;
    root.dataset.lcReady = 'true';
    const slides = [...root.querySelectorAll('.lc-hero__slide')];
    const dots = [...root.querySelectorAll('.lc-hero__dot')];
    if (slides.length < 2) return;
    let index = Math.max(0, slides.findIndex(s => s.classList.contains('is-active')));
    let timer = null;
    let paused = false;

    const show = next => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.toggleAttribute('inert', !active);
        if (active) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
      });
      dots.forEach((dot, i) => {
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };

    const stop = () => { clearInterval(timer); timer = null; };
    const start = () => {
      stop();
      if (root.dataset.autoplay !== 'true' || reduceMotion.matches || paused) return;
      timer = setInterval(() => show(index + 1), Number(root.dataset.interval) || 6000);
    };

    root.querySelector('.lc-hero__prev').addEventListener('click', () => { show(index - 1); start(); });
    root.querySelector('.lc-hero__next').addEventListener('click', () => { show(index + 1); start(); });
    dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); start(); }));

    const pause = () => { paused = true; stop(); };
    const resume = () => { paused = false; start(); };
    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', resume);
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', e => { if (!root.contains(e.relatedTarget)) resume(); });
    reduceMotion.addEventListener('change', start);

    // Theme editor: hiện slide của block đang chọn, dừng tự chuyển trong lúc chỉnh.
    root.addEventListener('shopify:block:select', e => { pause(); show(slides.indexOf(e.target)); });
    root.addEventListener('shopify:block:deselect', resume);

    start();
  };

  const initAll = () => document.querySelectorAll('[data-lc-hero]').forEach(init);
  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
